<template lang="pug">
#sub-empresa-tabela-gestao-contrato-originacao
    .tabela-gestao-contrato-originacao__tabela
        el-table(
            :data='tabelaData',
            v-loading='carregando',
            stripe,
            :default-sort='{ prop: "date", order: "descending" }',
            @sort-change='sortChangeRequest',
            pagerCount='10',
            style='width: 100%'
        )
            el-table-column(
                v-for='(column, index) in columns',
                :key='index',
                :prop='column.prop',
                :label='$t(column.label)',
                :width='column.width'
            )
                template(slot='empty')
                    el-empty(:description='$t("denuncia.words.empty")')

    .tabela-gestao-contrato-originacao__paginacao
        span.pagina
            | {{ paginacao.total }} {{ paginacao.total > 1 ? $t('denuncia.words.consults') : $t('denuncia.words.consult') }}

        el-pagination(
            background,
            :page-size='paginacao?.itensPorPagina',
            :pager-count='paginacao?.totalPaginas',
            :current-page.sync='paginacao.pagina + 1',
            layout='prev, pager, next',
            :total='paginacao.total',
            @current-change='mudarPagina'
        )
</template>

<script>
export default {
    name: 'TabelaContratosRelacionadosDenuncia',
    props: {
        tabelaData: {
            type: Array,
            required: true
        },
        carregando: {
            type: Boolean,
            required: true
        },
        paginacao: {
            type: Object,
            required: true
        },
        columns: {
            type: Array,
            required: true
        }
    },
    methods: {
        sortChangeRequest({ prop, order }) {
            this.$emit('sort-change', { prop, order });
        },
        mudarPagina(pagina) {
            this.$emit('mudar-pagina', pagina - 1);
        }
    }
};
</script>

<style lang="scss" scoped>
#sub-empresa-tabela-gestao-contrato-originacao {
    box-shadow: 0 0 10px rgb(0 0 0 / 10%);
    border-radius: 10px;

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;

        thead.has-gutter {
            height: 67px;

            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }
    }

    .el-table__cell {
        font-size: 12px;
    }

    .is-leaf {
        font-size: 13px;
    }

    .status-processamento {
        max-width: 148px;
        word-break: break-word;
        font-size: 13px;
        line-height: 17px;
    }

    .tabela-gestao-contrato-originacao__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        .pagina {
            color: var(--primary);
            font-weight: 600;
        }
    }

    .tabela-gestao-icone {
        i {
            font-size: 23px;
            cursor: pointer;
        }
    }
}
</style>
